import config from 'config/config'
import { classNames } from 'lib/utilities'
import React from 'react'
import Highlighter from 'react-highlight-words'
import { connect } from 'react-redux'
import { Icon, Table } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  const { product: loadedProduct } = state.product
  return { loadedProduct }
}

class ProductRow extends React.Component {
  getIconStyleStatus(product) {
    if (product.status === 'inactive')
      return <Icon {...config.icons.productStatusInactive} />
    if (product.status === 'archived')
      return <Icon {...config.icons.productStatusArchived} />
    if (product.status === 'active') return false
    return false
  }

  getIconStyleKind(product) {
    if (product.kind === 'family')
      return <Icon {...config.icons.productFamily} />
    if (product.family_ids.length > 0)
      return <Icon {...config.icons.productFamilyMember} />
    return false
  }

  render() {
    // redux
    const {
      product,
      onSelect,
      selectable,
      highlight,
      loadedProduct,
    } = this.props
    const iconStyleStatus = this.getIconStyleStatus(product)
    const iconStyleKind = this.getIconStyleKind(product)
    const rowProps = {
      warning: product.status === 'archived',
      className: classNames([
        product.kind === 'family' && 'product-family',
        product.family_ids.length > 0 && 'product-family-member',
        product.status ? 'status-' + product.status : false,
        selectable && 'selectable-' + selectable,
      ]),
      active:
        !selectable && product.article_number === loadedProduct.article_number,
      onClick: () => {
        onSelect(product.article_number)
      },
    }

    const highlightDefaults = {
      highlightClassName: 'highlight',
      searchWords: [highlight],
      aciveIndex: -1,
    }
    const selectIconCell = selectable && (
      <Table.Cell collapsing>
        <Icon name={`chevron ${selectable}`} color="blue" />
      </Table.Cell>
    )

    const title_de = (
      <span
        className="german tag single-line"
        children={
          highlight ? (
            <Highlighter
              {...highlightDefaults}
              textToHighlight={product.title_de}
            />
          ) : (
            product.title_de
          )
        }
      />
    )
    const title_fr = (
      <span
        className="french tag single-line"
        children={
          highlight ? (
            <Highlighter
              {...highlightDefaults}
              textToHighlight={product.title_fr}
            />
          ) : (
            product.title_fr
          )
        }
      />
    )

    return (
      <Table.Row {...rowProps}>
        {selectIconCell}
        <Table.Cell>
          {iconStyleStatus}
          {iconStyleKind}
          <strong>
            {highlight ? (
              <Highlighter
                {...highlightDefaults}
                textToHighlight={product.article_number}
              />
            ) : (
              product.article_number
            )}
          </strong>
          <br />
          {title_de}
          {title_fr}
        </Table.Cell>
      </Table.Row>
    )
  }
}

ProductRow = connect(mapStateToProps)(ProductRow)
export default ProductRow



// WEBPACK FOOTER //
// ./src/components/admin/Products/Segments/ProductRow.jsx